<template>
  <div class="Babillard">
    <div class="Babillard_Container section ">
      <b-container fluid>
        <b-row class="Babillard_ContainerTitle text-padding">
          <b-col>
            <h2 class="typo_block-title U--mb--0">
              {{ translations.babillard.fr.title }}
            </h2>
          </b-col>
          <b-col v-if="isVisible">
            <div class="U--text-align-right">
              <p class="promo U--mb--0">
                {{ translations.babillard.fr.promo }}
              </p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="8" class="Babillard_ContainerList">
            <BabillardListComponent :translation="translations.babillard.fr.errorMessage" />
          </b-col>
          <b-col v-if="isVisible" cols="12" lg="4" class="Babillard_ContainerImage">
            <a :href="translations.babillard.fr.pubUrl2" target="_blank">
              <img style="width: 100%;" src="@/assets/img/BigBox_Divertir.jpg" />
            </a>
          </b-col>
        </b-row>
        <b-row class="Babillard_ContainerPromo">
          <a :href="translations.babillard.fr.pubUrl" target="_blank">
            <img src="@/assets/img/Billboard_Divertir.jpg" />
          </a>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script lang="ts" setup>
import translations from '@/dictionaries/homepage.json';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import BabillardListComponent from './BabillardListComponent.vue';

const isVisible = ref(true);

const setPosition = () => {
  if (window.innerWidth >= 992) {
    isVisible.value = true;
  } else {
    isVisible.value = false;
  }
};

onMounted(() => {
  setPosition();
  window.addEventListener('resize', setPosition);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosition);
});

</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.Babillard {
  background-color: $sp-pampas;
  padding-top: 30px;
  padding-bottom: 15px;

  @media ($bp-min-md) {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  &_Container {
    &Title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-bottom: 20px;

      @media ($bp-min-md) {
        padding-bottom: 35px;
      }

      .typo_block-title {
        color: $sp-navy-blue;
      }
    }

    .promo {
      line-height: 1;
      color: rgba($sp-flint, 0.4);
    }

    &Image {
      text-align: end;
    }

    &Promo {
      display: flex;
      justify-content: center;
      padding-top: 37px;
      padding-bottom: 37px;

      @media ($bp-min-md) {
        padding-top: 60px;
        padding-bottom: 60px;
      }

      a {
        display: flex;
        justify-content: center;
      }

      img {
        // max-width: 300px;
        // width: 100%;
        width: calc(100% - 30px);

        @media ($bp-min-md) {
          max-width: 970px;
          width: 100%;
        }
      }
    }
  }
  &_ContainerList{
    padding-right: 20px;
    @media ($bp-max-md) {
      padding-right: 0px;
    }
  }
}
</style>